import angular from "angular";
import { IcdCorporationDashboardContainerComponent } from "./container/icd-corporation-dashboard-container.component";
import { IcdCorporationDashboardOfficesDetailsComponent } from './offices/icd-corporation-dashboard-offices-details.component';
import { IcdCorporationDashboardCorporationDetailsComponent } from './corporation/icd-corporation-dashboard-corporation-details.component';

export const IcdCorporationDashboardModule = angular
    .module("apex.mainApp.icdCorporation.dashboard", [])
    .component("apexIcdCorporationDashboardContainer", IcdCorporationDashboardContainerComponent)
    .component("apexIcdCorporationDashboardOfficesDetails", IcdCorporationDashboardOfficesDetailsComponent)
    .component("apexIcdCorporationDashboardCorporationDetails", IcdCorporationDashboardCorporationDetailsComponent)
    .name;
